module.exports = __webpack_public_path__ + "img/IMG-20220207-WA0028.304bbd89.jpg";